function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { StyleSheets } from '../../../stylesheets';
export class RuleCache {
    add(rule) {
        this.map[rule.key] = rule;
    }
    get(key) {
        return this.map[key];
    }
    _insertLayer(layer, path = '') {
        StyleSheets.schedule(()=>{
            StyleSheets.insert(layer.rulesets, path);
        });
        for(let i = 0; i < layer.order.length; i++){
            const segment = layer.order[i];
            this._insertLayer(layer.layers[segment], path ? `${path}.${segment}` : segment);
        }
    }
    insert(rule) {
        if (rule.inserted) {
            return;
        }
        this.forEachDependency(rule, (dep)=>this.insert(dep));
        this._insertLayer(rule.layer);
        rule.inserted = true;
    }
    forEachRule(keys, callback) {
        for(let i = 0; i < keys.length; i++){
            const rule = this.get(keys[i]);
            if (rule) {
                callback(rule);
            }
        }
    }
    forEachDependency(rule, callback) {
        if (rule.dependencies) {
            this.forEachRule(Object.values(rule.dependencies), callback);
        }
        if (rule.merged) {
            this.forEachRule(rule.merged, callback);
        }
    }
    constructor(){
        _define_property(this, "map", {});
        StyleSheets.onFlush(()=>{
            this.map = {};
        });
    }
}

//# sourceMappingURL=cache.js.map